import React, { useCallback, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { SIZES } from 'src/styles/theme'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getBooths } from 'src/ducks/booth'
import Amplitude from 'src/utils/amplitudeHelper'

const StyledModal = styled(Modal)`
  .modal-content {
    border: none;
    background: transparent;
    border-radius: 0;
  }
  .box-dialog {
    border-radius: 8px;
    width: 90%;
    margin: auto;
    max-height: 70vh;
    max-width: 500px;
    background-color: rgba(255, 255, 255, 1);
    text-align: center;
    padding: 2rem 20px;
    border: 1px solid #F8C605;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;

    p {
      font-weight: 700;
      color: #FFAF2A;
    }

    a {
      display: block;
      font-size: 16px;
      font-weight: bold;
      text-transform: uppercase;
      color: #000;
      text-decoration: none;
      margin-top: 12px;
      background: #F8C605;
      padding: 8px;
      border-radius: 8px;
      width: 100%;

      span {
        margin-right: 8px;
        visibility: hidden;
      }
      i {
        font-weight: 400;
      }
      &:hover {
        color: #fff;
        span {
          visibility: visible;
        }
      }
    }
  }
  button.close {
    opacity: 1;
    padding: 4px auto !important;
    z-index: 100;
    position: absolute;
    top: 5%;
    right: 5%;
    span {
      font-weight: 400;
      font-size: 24px;
      color: rgba(0, 0, 0, 0.9);
      text-shadow: none;
    }
  }
  ${SIZES.mobile} {
    .box-dialog {
      a {
        font-size: 14px;
        letter-spacing: 0;
      }
    }
  }
`

export default function ExhibitionEntryModal({ showModal, hideModal }) {
  const dispatch = useDispatch()
  const { booths } = useSelector((state) => state.booth)

  useEffect(() => {
    dispatch(getBooths(1))
    Amplitude.clickExhibition()
  }, [])

  const escFunction = useCallback(
    (event) => {
      if (event.keyCode === 27) {
        hideModal()
      }
    },
    [hideModal]
  )

  const clickOutsideToClose = (e) => {
    if ((e.target).id === 'ENTRY_SELECTION_MODAL') {
      hideModal()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  return (
    <StyledModal id={'ENTRY_SELECTION_MODAL'} show={showModal} onHide={hideModal} aria-labelledby="game-modal" size="lg" centered onClick={clickOutsideToClose}>
      <div className="box-dialog">
        <button className='close' onClick={hideModal}>
          <span>x</span>
        </button>
        <p>Select a booth to visit</p>
        {booths.length === 0 && <p className='text-muted text-center'>Loading...</p>}
        {booths.map((entry) => (
          <Link key={entry.title} to={`/booths/${entry.id}`} onClick={hideModal} dangerouslySetInnerHTML={{ __html: entry.title.replace(" | ", " | <br/>").replace("from", "<i>from</i><br/>") }} />
        ))}
      </div>
    </StyledModal>
  )
}
